// Italian translations
export const it = {
  // App
  appName: 'CarTrip',
  signIn: 'Accedi',
  signUp: 'Registrati',
  signOut: 'Esci',
  email: 'Email',
  password: 'Password',
  fullName: 'Nome Completo',
  
  // Navigation
  home: 'Home',
  profile: 'Profilo',
  settings: 'Impostazioni',
  menu: 'Menu',
  analytics: 'Analisi',
  
  // Trips
  myTrips: 'I Miei Viaggi',
  newTrip: 'Nuovo Viaggio',
  selectTrip: 'Seleziona Viaggio',
  tripName: 'Nome del Viaggio',
  createTrip: 'Crea Viaggio',
  deleteTrip: 'Elimina Viaggio',
  stops: 'fermate',
  tripHistory: 'Cronologia Viaggi',
  
  // Stops
  addStop: 'Aggiungi Fermata',
  editStop: 'Modifica Fermata',
  deleteStop: 'Elimina Fermata',
  noStops: 'Nessuna fermata',
  
  // Stop types
  city: 'Città',
  gasStation: 'Stazione di Servizio',
  evCharging: 'Ricarica EV',
  restaurant: 'Ristorante',
  hotel: 'Hotel',
  attraction: 'Attrazione',
  parking: 'Parcheggio',
  other: 'Altro',
  
  // Common
  cancel: 'Annulla',
  delete: 'Elimina',
  close: 'Chiudi',
  save: 'Salva',
  search: 'Cerca',
  loading: 'Caricamento...',
}
